module.exports = "/images/Arrow-Small-down.png?3bff48bf2051a5dced3d3fe100eb6e39";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/Arrow-Small-down.png
// module id = zQOA
// module chunks = 1